export default "__VITE_ASSET__c542e7d9__"